@if(!templateForPermitForm){
  <div [ngClass]="{'form-group': showLabel}">
    <wm-de-label
      [entity]="entity"
      [for]="entity.templateCode"
      [displayOnly]="true"
      *ngIf="showLabel"
    ></wm-de-label>
    <input
      type="text"
      readonly
      *ngIf="!entity.isMultiline"
      class="form-control-plaintext"
      [id]="entity.templateCode"
      [value]="entity.value || ''"
    />

    <textarea
      class="form-control-plaintext"
      readonly
      *ngIf="entity.isMultiline"
      rows="5"
      [name]="entity.templateCode"
      [id]="entity.templateCode"
      >{{ entity.value || '' }}</textarea
    >
  </div>
}
        <!-- added by priya 17-12-2025 -->

@else {
  <div class="free-form-text-style">
<!-- Added by Amisha on 03-07-2026.
      Reason: Janus table-layout view screens already render the row label in the left cell,
      so the readonly value cell should only render this label when showLabel is true. -->
    <wm-common-text
      *ngIf="showLabel"
      [data]="{    text: getEntityLabelText(),
    }"
      class="entity-text"

    >
    </wm-common-text>
    <wm-common-text
      *ngIf="!entity.isMultiline"
      [data]="{
        text: entity.value || '',
        multiline: false
      }"
    >
    </wm-common-text>

    <wm-common-text
      *ngIf="entity.isMultiline"
      [data]="{
        text: entity.value || '',
        multiline: true
      }"
    >
    </wm-common-text>
  </div>
}
  <!-- end by priya 17-12-2025 -->
